import { cn as e } from "../lib/utils.js";
import { Button as t } from "./button.js";
import { Input as n } from "./input.js";
import { Separator as r } from "./separator.js";
import { Sheet as i, SheetContent as a, SheetDescription as o, SheetHeader as s, SheetTitle as c } from "./sheet.js";
import { useIsMobile as l } from "../hooks/use-mobile.js";
import { Skeleton as u } from "./skeleton.js";
import { Tooltip as d, TooltipContent as f, TooltipTrigger as p } from "./tooltip.js";
import * as m from "react";
import { cva as h } from "class-variance-authority";
import { jsx as g, jsxs as _ } from "react/jsx-runtime";
import { Slot as v } from "@radix-ui/react-slot";
import { PanelLeft as y } from "lucide-react";
import b from "js-cookie";
//#region src/shadcn/sidebar.tsx
var x = "sidebar_state", S = 604800, C = "16rem", w = "18rem", T = "3rem", E = "b", D = m.createContext(null);
function O() {
	let e = m.useContext(D);
	if (!e) throw Error("useSidebar must be used within a SidebarProvider.");
	return e;
}
var k = m.forwardRef(({ defaultOpen: t = !0, open: n, onOpenChange: r, className: i, style: a, children: o, ...s }, c) => {
	let u = l(), [d, f] = m.useState(!1), p = m.useCallback(() => {
		let e = b.get(x);
		return e == null ? t : e.toLowerCase() === "true";
	}, [t]), [h, _] = m.useState(p), v = n == null ? h : n, y = m.useCallback((e) => {
		let t = typeof e == "function" ? e(v) : e;
		r ? r(t) : _(t), b.set(x, t.toString(), {
			path: "/",
			expires: S / 86400
		});
	}, [r, v]), w = m.useCallback(() => u ? f((e) => !e) : y((e) => !e), [
		u,
		y,
		f
	]);
	m.useEffect(() => {
		let e = (e) => {
			e.key === E && (e.metaKey || e.ctrlKey) && (e.preventDefault(), w());
		};
		return window.addEventListener("keydown", e), () => window.removeEventListener("keydown", e);
	}, [w]);
	let O = v ? "expanded" : "collapsed", k = m.useMemo(() => ({
		state: O,
		open: v,
		setOpen: y,
		isMobile: u,
		openMobile: d,
		setOpenMobile: f,
		toggleSidebar: w
	}), [
		O,
		v,
		y,
		u,
		d,
		f,
		w
	]);
	return /* @__PURE__ */ g(D.Provider, {
		value: k,
		children: /* @__PURE__ */ g("div", {
			style: {
				"--sidebar-width": C,
				"--sidebar-width-icon": T,
				...a
			},
			className: e("group/sidebar-wrapper flex min-h-svh w-full has-[[data-variant=inset]]:bg-sidebar", i),
			ref: c,
			...s,
			children: o
		})
	});
});
k.displayName = "SidebarProvider";
var A = m.forwardRef(({ side: t = "left", variant: n = "sidebar", collapsible: r = "offcanvas", className: l, children: u, ...d }, f) => {
	let { isMobile: p, state: m, openMobile: h, setOpenMobile: v } = O();
	return r === "none" ? /* @__PURE__ */ g("div", {
		className: e("flex h-full w-[--sidebar-width] flex-col bg-sidebar text-sidebar-foreground", l),
		ref: f,
		...d,
		children: u
	}) : p ? /* @__PURE__ */ g(i, {
		open: h,
		onOpenChange: v,
		...d,
		children: /* @__PURE__ */ _(a, {
			"data-sidebar": "sidebar",
			"data-mobile": "true",
			className: "w-[--sidebar-width] bg-sidebar p-0 text-sidebar-foreground [&>button]:hidden",
			style: { "--sidebar-width": w },
			side: t,
			children: [/* @__PURE__ */ _(s, {
				className: "sr-only",
				children: [/* @__PURE__ */ g(c, { children: "Sidebar" }), /* @__PURE__ */ g(o, { children: "Displays the mobile sidebar." })]
			}), /* @__PURE__ */ g("div", {
				className: "flex h-full w-full flex-col",
				children: u
			})]
		})
	}) : /* @__PURE__ */ _("div", {
		ref: f,
		className: "group peer hidden text-core-foreground md:block",
		"data-state": m,
		"data-collapsible": m === "collapsed" ? r : "",
		"data-variant": n,
		"data-side": t,
		children: [/* @__PURE__ */ g("div", { className: e("relative w-[--sidebar-width] transition-[width] duration-200 ease-linear", "group-data-[collapsible=offcanvas]:w-0", "group-data-[side=right]:rotate-180", n === "floating" || n === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4))]" : "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.2))]") }), /* @__PURE__ */ g("div", {
			className: e("fixed inset-y-0 z-10 hidden h-svh w-[--sidebar-width] transition-[left,right,width] duration-200 ease-linear md:flex", t === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]", n === "floating" || n === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4)_+2px)]" : "p-1 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.2))]", l),
			...d,
			children: /* @__PURE__ */ g("div", {
				"data-sidebar": "sidebar",
				className: "flex h-full w-full flex-col rounded-lg bg-core-decorative group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:border-sidebar-border group-data-[variant=floating]:shadow",
				children: u
			})
		})]
	});
});
A.displayName = "Sidebar";
var j = m.forwardRef(({ className: n, onClick: r, ...i }, a) => {
	let { toggleSidebar: o } = O();
	return /* @__PURE__ */ _(t, {
		ref: a,
		"data-sidebar": "trigger",
		variant: "ghost",
		size: "icon",
		className: e("h-7 w-7", n),
		onClick: (e) => {
			r == null || r(e), o();
		},
		...i,
		children: [/* @__PURE__ */ g(y, {}), /* @__PURE__ */ g("span", {
			className: "sr-only",
			children: "Toggle Sidebar"
		})]
	});
});
j.displayName = "SidebarTrigger";
var M = m.forwardRef(({ className: t, ...n }, r) => {
	let { toggleSidebar: i } = O();
	return /* @__PURE__ */ g("button", {
		ref: r,
		"data-sidebar": "rail",
		"aria-label": "Toggle Sidebar",
		tabIndex: -1,
		onClick: i,
		title: "Toggle Sidebar",
		className: e("absolute inset-y-0 z-20 hidden w-4 -translate-x-1/2 transition-all ease-linear after:absolute after:inset-y-0 after:left-1/2 after:w-[2px] hover:after:bg-sidebar-border group-data-[side=left]:-right-4 group-data-[side=right]:left-0 sm:flex", "[[data-side=left]_&]:cursor-w-resize [[data-side=right]_&]:cursor-e-resize", "[[data-side=left][data-state=collapsed]_&]:cursor-e-resize [[data-side=right][data-state=collapsed]_&]:cursor-w-resize", "group-data-[collapsible=offcanvas]:translate-x-0 group-data-[collapsible=offcanvas]:after:left-full group-data-[collapsible=offcanvas]:hover:bg-sidebar", "[[data-side=left][data-collapsible=offcanvas]_&]:-right-2", "[[data-side=right][data-collapsible=offcanvas]_&]:-left-2", t),
		...n
	});
});
M.displayName = "SidebarRail";
var N = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ g("main", {
	ref: r,
	className: e("relative flex w-full flex-1 flex-col bg-background", "md:peer-data-[variant=inset]:m-2 md:peer-data-[state=collapsed]:peer-data-[variant=inset]:ml-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow", t),
	...n
}));
N.displayName = "SidebarInset";
var P = m.forwardRef(({ className: t, ...r }, i) => /* @__PURE__ */ g(n, {
	ref: i,
	"data-sidebar": "input",
	className: e("h-8 w-full bg-background shadow-none focus-visible:ring-2 focus-visible:ring-sidebar-ring", t),
	...r
}));
P.displayName = "SidebarInput";
var F = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ g("div", {
	ref: r,
	"data-sidebar": "header",
	className: e("flex flex-col gap-2 p-2", t),
	...n
}));
F.displayName = "SidebarHeader";
var I = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ g("div", {
	ref: r,
	"data-sidebar": "footer",
	className: e("flex flex-col gap-2 p-2", t),
	...n
}));
I.displayName = "SidebarFooter";
var L = m.forwardRef(({ className: t, ...n }, i) => /* @__PURE__ */ g(r, {
	ref: i,
	"data-sidebar": "separator",
	className: e("mx-2 w-auto bg-sidebar-border", t),
	...n
}));
L.displayName = "SidebarSeparator";
var R = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ g("div", {
	ref: r,
	"data-sidebar": "content",
	className: e("flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden", t),
	...n
}));
R.displayName = "SidebarContent";
var z = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ g("div", {
	ref: r,
	"data-sidebar": "group",
	className: e("relative flex w-full min-w-0 flex-col p-2", t),
	...n
}));
z.displayName = "SidebarGroup";
var B = m.forwardRef(({ className: t, asChild: n = !1, ...r }, i) => /* @__PURE__ */ g(n ? v : "div", {
	ref: i,
	"data-sidebar": "group-label",
	className: e("flex h-8 shrink-0 items-center rounded-md px-2 text-xs font-medium text-core-foregroundSubdued outline-none ring-sidebar-ring transition-[margin,opacity] duration-200 ease-linear focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0", "group-data-[collapsible=icon]:-mt-8 group-data-[collapsible=icon]:opacity-0", t),
	...r
}));
B.displayName = "SidebarGroupLabel";
var V = m.forwardRef(({ className: t, asChild: n = !1, ...r }, i) => /* @__PURE__ */ g(n ? v : "button", {
	ref: i,
	"data-sidebar": "group-action",
	className: e("absolute right-3 top-3.5 flex aspect-square w-5 items-center justify-center rounded-md p-0 text-core-foreground outline-none ring-sidebar-ring transition-transform hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0", "after:absolute after:-inset-2 after:md:hidden", "group-data-[collapsible=icon]:hidden", t),
	...r
}));
V.displayName = "SidebarGroupAction";
var H = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ g("div", {
	ref: r,
	"data-sidebar": "group-content",
	className: e("w-full text-sm", t),
	...n
}));
H.displayName = "SidebarGroupContent";
var U = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ g("ul", {
	ref: r,
	"data-sidebar": "menu",
	className: e("flex w-full min-w-0 flex-col gap-2", t),
	...n
}));
U.displayName = "SidebarMenu";
var W = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ g("li", {
	ref: r,
	"data-sidebar": "menu-item",
	className: e("group/menu-item relative", t),
	...n
}));
W.displayName = "SidebarMenuItem";
var G = h("peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-none ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-has-[[data-sidebar=menu-action]]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:!size-8 group-data-[collapsible=icon]:!p-2 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0", {
	variants: {
		variant: {
			default: "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
			outline: "bg-background shadow-[0_0_0_1px_hsl(var(--sidebar-border))] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_hsl(var(--sidebar-accent))]"
		},
		size: {
			default: "h-8 text-sm",
			sm: "h-7 text-xs",
			lg: "h-16 text-sm group-data-[collapsible=icon]:!p-0"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
}), K = m.forwardRef(({ asChild: t = !1, isActive: n = !1, variant: r = "default", size: i = "default", tooltip: a, className: o, ...s }, c) => {
	let l = t ? v : "button", { isMobile: u, state: m } = O(), h = /* @__PURE__ */ g(l, {
		ref: c,
		"data-sidebar": "menu-button",
		"data-size": i,
		"data-active": n,
		className: e(G({
			variant: r,
			size: i
		}), o),
		...s
	});
	return a ? (typeof a == "string" && (a = { children: a }), /* @__PURE__ */ _(d, {
		delayDuration: 300,
		children: [/* @__PURE__ */ g(p, {
			asChild: !0,
			children: h
		}), /* @__PURE__ */ g(f, {
			side: "right",
			align: "center",
			hidden: m !== "collapsed" || u,
			...a
		})]
	})) : h;
});
K.displayName = "SidebarMenuButton";
var q = m.forwardRef(({ className: t, asChild: n = !1, showOnHover: r = !1, ...i }, a) => /* @__PURE__ */ g(n ? v : "button", {
	ref: a,
	"data-sidebar": "menu-action",
	className: e("absolute right-1 top-1.5 flex aspect-square w-5 items-center justify-center rounded-md p-0 text-sidebar-foreground outline-none ring-sidebar-ring transition-transform hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 peer-hover/menu-button:text-sidebar-accent-foreground [&>svg]:size-4 [&>svg]:shrink-0", "after:absolute after:-inset-2 after:md:hidden", "peer-data-[size=sm]/menu-button:top-1", "peer-data-[size=default]/menu-button:top-1.5", "peer-data-[size=lg]/menu-button:top-2.5", "group-data-[collapsible=icon]:hidden", r && "group-focus-within/menu-item:opacity-100 group-hover/menu-item:opacity-100 data-[state=open]:opacity-100 peer-data-[active=true]/menu-button:text-sidebar-accent-foreground md:opacity-0", t),
	...i
}));
q.displayName = "SidebarMenuAction";
var J = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ g("div", {
	ref: r,
	"data-sidebar": "menu-badge",
	className: e("pointer-events-none absolute right-1 flex h-5 min-w-5 select-none items-center justify-center rounded-md px-1 text-xs font-medium tabular-nums text-sidebar-foreground", "peer-hover/menu-button:text-sidebar-accent-foreground peer-data-[active=true]/menu-button:text-sidebar-accent-foreground", "peer-data-[size=sm]/menu-button:top-1", "peer-data-[size=default]/menu-button:top-1.5", "peer-data-[size=lg]/menu-button:top-2.5", "group-data-[collapsible=icon]:hidden", t),
	...n
}));
J.displayName = "SidebarMenuBadge";
var Y = m.forwardRef(({ className: t, showIcon: n = !1, ...r }, i) => {
	let a = m.useMemo(() => `${Math.floor(Math.random() * 40) + 50}%`, []);
	return /* @__PURE__ */ _("div", {
		ref: i,
		"data-sidebar": "menu-skeleton",
		className: e("flex h-8 items-center gap-2 rounded-md px-2", t),
		...r,
		children: [n && /* @__PURE__ */ g(u, {
			className: "size-4 rounded-md",
			"data-sidebar": "menu-skeleton-icon"
		}), /* @__PURE__ */ g(u, {
			className: "h-4 max-w-[--skeleton-width] flex-1",
			"data-sidebar": "menu-skeleton-text",
			style: { "--skeleton-width": a }
		})]
	});
});
Y.displayName = "SidebarMenuSkeleton";
var X = m.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ g("ul", {
	ref: r,
	"data-sidebar": "menu-sub",
	className: e("mx-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l border-sidebar-border px-2.5 py-0.5", "group-data-[collapsible=icon]:hidden", t),
	...n
}));
X.displayName = "SidebarMenuSub";
var Z = m.forwardRef(({ ...e }, t) => /* @__PURE__ */ g("li", {
	ref: t,
	...e
}));
Z.displayName = "SidebarMenuSubItem";
var Q = m.forwardRef(({ asChild: t = !1, size: n = "md", isActive: r, className: i, ...a }, o) => /* @__PURE__ */ g(t ? v : "a", {
	ref: o,
	"data-sidebar": "menu-sub-button",
	"data-size": n,
	"data-active": r,
	className: e("flex h-7 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-2 text-sidebar-foreground outline-none ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0 [&>svg]:text-sidebar-accent-foreground", "data-[active=true]:bg-sidebar-accent data-[active=true]:text-sidebar-accent-foreground", n === "sm" && "text-xs", n === "md" && "text-sm", "group-data-[collapsible=icon]:hidden", i),
	...a
}));
Q.displayName = "SidebarMenuSubButton";
//#endregion
export { A as Sidebar, R as SidebarContent, I as SidebarFooter, z as SidebarGroup, V as SidebarGroupAction, H as SidebarGroupContent, B as SidebarGroupLabel, F as SidebarHeader, P as SidebarInput, N as SidebarInset, U as SidebarMenu, q as SidebarMenuAction, J as SidebarMenuBadge, K as SidebarMenuButton, W as SidebarMenuItem, Y as SidebarMenuSkeleton, X as SidebarMenuSub, Q as SidebarMenuSubButton, Z as SidebarMenuSubItem, k as SidebarProvider, M as SidebarRail, L as SidebarSeparator, j as SidebarTrigger, O as useSidebar };
